export const experiences = [
    {
        title: "Software Engineer",
        company: "Dynamic Build Systems",
        date: "June 2025 - Present",
        icon: "mdi:language-csharp",
        backgroundColor: "#404040",
        badges: ["Manufacturing", "C# .NET, ", "SQL"],
    },
    {
        title: "Software Engineer",
        company: "Culture Systems",
        date: "Jul 2024 - May 2025",
        icon: "mdi:language-rust",
        backgroundColor: "#404040",
        badges: ["Agri-Manufacturing", "Flutter, ", "Rust"],
    },
    {
        title: "Software Engineer",
        company: "Kaha",
        date: "Oct 2023 - June 2024",
        icon: "mdi:language-csharp",
        backgroundColor: "#404040",
        badges: ["Fintech", "C# .NET, ", "React, ", "AWS"],
    },
    {
        title: "Jewellery Designer",
        company: "Self Employed",
        date: "Oct 2014 - 2023",
        icon: "mdi:diamond",
        backgroundColor: "#404040",
        badges: [
            "Design",
            "Designing custom engagement rings and jewellery. ",
            "Communicating with customers. ",
            "Providing beneficial advice and support. ",
            "Maintaining a loyal customer base.",
        ],
    },
];